export default [
  {
    id: 'taishokuprofile',
    title: '所属',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'company',
    title: '宛名',
    previewJumpId: 'company'
  },
  {
    id: 'taishokureason',
    title: '退職理由',
    previewJumpId: 'reason'
  },
  {
    id: 'retirement-date',
    title: '退職日',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'confirm',
    title: '確認',
    previewJumpId: 'confirm-preview'
  },
  {
    id: 'output',
    title: '完了',
    previewJumpId: 'preview-page-01'
  }
]
